/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo } from "react";
import { useTable, useGlobalFilter, useSortBy, usePagination, useRowSelect, useExpanded, useFilters } from "react-table";
import { ApiLogsColumn } from "./ApiLogsColumn";
import { FaSortDown, FaSortUp, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight, FaEdit, FaTrash, FaPlus, FaCodeBranch } from "react-icons/fa";
import { BASE_URL, NODE_API_URL } from "../../../../env_config";
import axios from "axios";
import Cookies from "js-cookie"
import { useHistory } from "react-router-dom";
export const ApiLogs = (props) => {
    const [data, setData] = useState([])
    const history = useHistory();
    const [totallimits, setTotalLimit] = useState("")
    const [current, setCurrent] = useState(0)
    const [pagenumber, setPageNumber] = useState(1)
    const [logCount, setLogCount] = useState(0)
    useEffect(() => {
        const params = {
            page: pagenumber
        }
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/get-api-logs`,
            params: params,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            }
        }).then(supreq => {
            if (supreq && supreq.data && supreq.data.data) {
                // setFeedLoader(false)
                setTotalLimit(supreq.data?.totallimit || "")
                setCurrent(supreq.data?.totalapicountcurrent || 0)
                setLogCount(supreq.data?.totalcount || 0)
                setData(supreq.data.data)
            }
        }).
            catch(error => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            })
    }, [pagenumber])
    const columns = useMemo(() => ApiLogsColumn(props.userinfo), []);
    const {
        getTableProps,
        getTableBodyProps,
        prepareRow,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        pageCount,
        setPageSize,
        setGlobalFilter,
        state: { globalFilter, pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data: data,
            initialState: {
                pageSize: 10, // Set the default page size to 100
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [
                    ...columns
                ].filter(Boolean);
            });
        }
    );
    return (
        <div className="row">
            <div className="col-12 mb-4 setting-title d-flex justify-content-between">
                API LOGS
                <button className="btn btn-text-dark btn-hover-light-dark" onClick={() => history.push({
                    pathname: "/diamondfeed"
                })}><FaCodeBranch className="font-size-h5 mr-2" />Rule Page</button>
            </div>
            <div className="col-12 text-md-right">
                    <div className="d-flex align-items-center justify-content-md-end">
                        <div className="mr-3">
                            <span className="text-muted mr-1">API Limit:</span>
                            <span className="font-weight-bold">{totallimits}</span>
                        </div>
                        <div>
                            <span className="text-muted mr-1">Current API Call:</span>
                            <span className="font-weight-bold">{current}</span>
                        </div>
               
                </div>
            </div>
            <div className="col-12">

                <div className="table-responsive custom-scrollbar w-100 mt-4">
                    <table className="table table-hover" {...getTableProps()} >
                        <thead className="custom_datatable_head">
                            {headerGroups.map((headerGroup, i) => (
                                <tr key={i} {...headerGroup.getHeaderGroupProps()} >
                                    {headerGroup.headers.map(
                                        (column, i) => (
                                            <th key={i} className="text-center text-nowrap align-middle" {...column.getHeaderProps(column.getSortByToggleProps())}>
                                                {column.render("Header")}
                                                <span className="text-secondary">
                                                    {column.isSorted ? (column.isSortedDesc ? (<FaSortDown />) : (<FaSortUp />)) : ("")}
                                                </span>
                                            </th>
                                        )
                                    )}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {data.length !== 0 ? page.map((row) => {
                                prepareRow(row)
                                return (
                                    <React.Fragment key={row.id}>
                                        <tr {...row.getRowProps()} key={row.id} className={`${row.original.is_delete === 1 ? "bg-danger-o-20" : null}`}>
                                            {row.cells.map((cell, i) => {
                                                return <td className="text-center align-middle" {...cell.getCellProps({ className: cell.column.className })} key={i}>{cell.render('Cell')}</td>
                                            })}
                                        </tr>
                                    </React.Fragment>
                                )
                            }) :
                                <tr>
                                    <td className="text-center align-middle" colSpan="100%">
                                        No data found
                                    </td>
                                </tr>}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="d-flex  col-12 align-items-center justify-content-between">
                <span className="table_page_length">Page{' '}{pagenumber} of {Math.ceil(logCount / 10)} {' '}</span>
                <div>
                    <button className="btn btn-sm btn-light mr-2" onClick={() => {
                        setPageNumber(1)
                    }} disabled={pagenumber === 1}><FaAngleDoubleLeft /></button>
                    <button className="btn btn-sm btn-light mr-2" onClick={() => {
                        setPageNumber(pagenumber - 1)
                    }} disabled={pagenumber === 1}><FaAngleLeft /></button>
                    <span className="font-weight-bold text-muted">{'  '}
                        <input
                            className="form-control d-inline-block form-control-sm"
                            type="number"
                            value={pagenumber}
                            // defaultValue={pagenumber}
                            // onChange={ e => { 
                            //     const pagenumber=e.target.value ? Number(e.target.value) - 1 : 0
                            //     gotoPage(pagenumber)
                            // }}
                            disabled={true}
                            style={{ maxWidth: '70px' }}
                        />
                        {'  '}of{'  '} {Math.ceil(logCount / 10)}{'  '}
                    </span>
                    <button className="btn btn-sm btn-light mr-2" onClick={() => {
                        setPageNumber(pagenumber + 1)
                    }} disabled={pagenumber >= Math.ceil(logCount / 10)}><FaAngleRight /></button>
                    <button className="btn btn-sm btn-light" onClick={() => {
                        setPageNumber(Math.ceil(logCount / 10))
                    }} disabled={pagenumber >= Math.ceil(logCount / 10)}><FaAngleDoubleRight /></button>
                </div>
                <span className="d-flex align-items-center">
                    <span className="text-nowrap page_size">Rows Per page:{' '}</span>
                    <select className="form-select ml-2 custom-select py-1" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                        {
                            [100].map(pageSize => (
                                <option key={pageSize} value={pageSize}>{pageSize}</option>
                            ))
                        }
                    </select>
                </span>
            </div>
        </div>
    );
};
